export default "__VITE_ASSET__edf75334__"